/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import SidebarDetail from './SidebarDetail'

import styled from '@emotion/styled'


const StyledImg = styled('img')`
  max-width: 120px;
  display: block;
`

const StyledSpan = styled('span')`
  font-size: 24px;
  display: block;
  font-weight: normal;
  font-family: ${({ theme }) => theme.fonts.light};
  margin-top: 24px;
`

const SidebarHeaderLogo = ({ logo, type }) => (
  <SidebarDetail>
    <StyledImg src={`images/${logo}`} alt={type} />
    <StyledSpan>{type}</StyledSpan>
  </SidebarDetail>
)

SidebarHeaderLogo.propTypes = {
  logo: PropTypes.string,
  type: PropTypes.string,
}

export default SidebarHeaderLogo
